import { render, staticRenderFns } from "./ImageUploadDialog.vue?vue&type=template&id=801bc12a&scoped=true&"
import script from "./ImageUploadDialog.vue?vue&type=script&lang=ts&"
export * from "./ImageUploadDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ImageUploadDialog.vue?vue&type=style&index=0&id=801bc12a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801bc12a",
  null
  
)

export default component.exports